<template>
    <div class="fullscreen" v-show="modals.fullscreen"
         :class="{mobile: isMobile, 'cabinet-modern': modernCabinet, light: modernCabinet && lightTheme}"
         :style="cabinetStyle">
        <header :class="{mobile: isMobile}" class="fs">
            <div class="empty" v-show="isMobile"></div>
            <a :href="logoRedirectTo || website" target="_blank" :class="{mobile: isMobile}">
                <img 
                    :src="logoComputed" 
                    :style="{height: logo.height}" 
                    :class="{hide: !logo.url}" 
                    @error="errorHandler"
                    @click="logoClickHandler"
                />
                <span :class="{hide: logo.url}">
                    <span class="brand">{{ tokens.header.cfd}}</span> 
                    {{ tokens.header.platform }}
                </span>
            </a>
            <div class="switch" v-if="whiteTheme && !isMobile && !onlyWhiteTheme" :class="{active: lightTheme}" @click="switchTheme">
                <div class="dark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 26" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8541 25.5321C14.9465 26.0547 12.9292 26.1218 10.9631 25.7281C8.99706 25.3343 7.13654 24.4907 5.52997 23.2644C3.92339 22.0381 2.6152 20.463 1.70972 18.6649C0.804239 16.8667 0.32652 14.8952 0.314659 12.9075C0.302796 10.9198 0.75712 8.97095 1.6414 7.21636C2.52568 5.46177 3.81545 3.94997 5.40785 2.80153C7.00026 1.65309 8.85124 0.899784 10.8132 0.601678C12.7752 0.303572 14.7938 0.468917 16.7082 1.08453C14.4117 1.6864 12.3558 2.93599 10.783 4.68588C9.67642 5.91662 8.83084 7.3602 8.29457 8.93408C7.7583 10.5079 7.54185 12.1812 7.65761 13.8583C7.77338 15.5353 8.21907 17.1831 8.96922 18.7076C9.71936 20.2321 10.7592 21.6032 12.0294 22.7427C13.419 24.0142 15.0677 24.9674 16.8541 25.5321Z" fill="#fff"/>
                        </svg>
                    </div>

                    <div class="light">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 23 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.51448 3.82869C7.21508 3.70277 6.12701 3.27318 5.58662 3.08801C5.15895 2.92709 4.71196 2.82496 4.25757 2.78433C4.07501 2.84359 4.07501 3.76203 4.13343 4.31753C4.19185 4.87304 4.39632 5.5989 4.44014 5.93961C4.6227 6.97656 7.82118 3.97682 7.51448 3.85831V3.82869ZM13.9772 2.91025C13.7946 2.59917 13.1958 1.56222 12.9475 1.07338C12.725 0.677215 12.4415 0.319654 12.1077 0.0142102C11.9252 -0.111705 11.3191 0.628971 11.0781 1.05856C10.8371 1.48815 10.4136 2.23624 10.2967 2.48066C9.74904 3.3991 14.1013 3.22133 13.948 2.91025H13.9772ZM14.2766 5.19894C13.5276 5.00082 12.7576 4.89635 11.9836 4.88785C11.2288 4.89629 10.4781 5.0008 9.74904 5.19894C8.01982 5.74779 6.54164 6.90676 5.58235 8.46584C4.62305 10.0249 4.24611 11.881 4.51981 13.6976C4.79352 15.5143 5.69977 17.1715 7.07435 18.3688C8.44893 19.5662 10.2009 20.2245 12.0128 20.2245C13.8247 20.2245 15.5767 19.5662 16.9513 18.3688C18.3258 17.1715 19.2321 15.5143 19.5058 13.6976C19.7795 11.881 19.4026 10.0249 18.4433 8.46584C17.484 6.90676 16.0058 5.74779 14.2766 5.19894ZM19.4686 6.42105C19.5344 6.05071 19.7096 4.88785 19.8338 4.33975C19.9457 3.89442 19.9655 3.43042 19.8922 2.97691C19.8338 2.79174 18.9283 2.91766 18.3879 3.09542C17.8475 3.27318 17.1757 3.59167 16.9274 3.65092C15.905 4.01386 19.4029 6.70991 19.4613 6.40624L19.4686 6.42105ZM21.5206 12.6649C21.7616 12.4798 22.6744 11.6872 23.0907 11.3169C23.4442 11.0445 23.7502 10.7141 23.9962 10.3392C24.0619 10.1541 23.2659 9.66521 22.7328 9.48004C22.1998 9.29487 21.5206 9.05045 21.2724 8.93194C20.25 8.5616 21.2139 12.9094 21.5133 12.6353L21.5206 12.6649ZM19.0451 18.7903H21.1044C21.574 18.8125 22.0439 18.7498 22.4919 18.6052C22.6744 18.5459 22.3093 17.6275 22.0683 17.1238C21.7755 16.6726 21.5121 16.2025 21.2797 15.7165C20.7393 14.8573 18.7457 18.7755 19.0451 18.7755V18.7903ZM13.3126 21.916C13.5536 22.0937 14.4591 22.8937 14.8827 23.2566C15.2265 23.5598 15.6129 23.8094 16.0292 23.9973C16.2702 24.0565 16.5769 23.1381 16.6937 22.59C16.8105 22.0419 16.8763 21.3012 16.9347 20.9901C17.1172 19.9532 13.0717 21.6715 13.2834 21.916H13.3126ZM6.9741 20.5457C7.03252 20.8494 7.21508 22.0271 7.33192 22.5678C7.36805 23.0153 7.4922 23.451 7.69704 23.8491C7.8796 24.0343 8.66827 23.6047 9.08451 23.2344C9.50075 22.864 10.0557 22.3826 10.2967 22.1974C11.0781 21.5234 6.91568 20.1754 6.9741 20.5457ZM2.93582 15.3388C2.81168 15.5832 2.20558 16.6276 1.9719 17.1164C1.70312 17.5 1.51656 17.9365 1.42421 18.3978C1.42421 18.5829 2.32972 18.7681 2.88471 18.7681H4.44014C5.64504 18.7681 3.04536 15.1536 2.92852 15.3388H2.93582ZM3.17681 8.72455C2.8774 8.85046 1.78934 9.27265 1.24165 9.46522C0.804243 9.60221 0.390397 9.80709 0.0148327 10.0726C-0.102007 10.2577 0.496796 10.991 0.92034 11.2947C1.34388 11.5984 1.89157 12.1539 2.13255 12.339C2.91392 13.0131 3.4543 8.63567 3.1549 8.72455H3.17681Z" fill="#258BD4"/>
                        </svg>
                    </div>
            </div>
            <div v-if="!moduleFtd" class="head" :class="{mobile: isMobile}">
                <button @click="close" class="fs-normal">{{ tokens.header.myAccount }}</button>
            </div>
        </header>

        <div class="menu" :class="{mobile: isMobile}">
            <HamburgerMenu/>
        </div>
        <div class="empty-aside menu" :class="{hide:!isMobile}">
            <HamburgerMenu/>
        </div>
        <main :class="{dashboard: modalFullscreen.page === 'dashboard'}" class="fs" ref="fullscreen">
            <Dashboard class="cabinet-item dashboard" v-if="modalFullscreen.page==='dashboard'"/>
            <!-- if to rebuild chart every time (fixes sizing) -->
            <Personal class="cabinet-item" v-show="modalFullscreen.page==='personal'"/>
            <Deposit class="cabinet-item" v-show="modalFullscreen.page==='deposit'"/>
            <Withdrawal class="cabinet-item" v-show="modalFullscreen.page==='withdrawal'"/>
            <Verification class="cabinet-item" v-show="modalFullscreen.page==='verification'"/>
            <Accounts class="cabinet-item" v-show="modalFullscreen.page==='accounts'"/>
            <Support :class="{mobile: isMobile}" class="cabinet-item support" v-show="modalFullscreen.page==='support'"/>
            <Savings class="cabinet-item" v-show="modalFullscreen.page==='savings'"/>
            <Settings class="cabinet-item" v-show="modalFullscreen.page==='settings'"/>
        </main>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {MODAL, MODAL_FULLSCREEN} from '@/store/mutations.type'
import {LOGO, WEBSITE, TRADINGVIEW_THEME, MODULE_FTD, WHITE_THEME, TRADINGVIEW_BG, TRADINGVIEW_LINE, DEFAULT_WHITE_THEME, ONLY_WHITE_THEME, LOGO_REDIRECT_TO, CABINET_DESIGN, CABINET_VARIABLES} from "@/common/config"
import {isMobile} from '@/common/helpers'
import {tokenOverrides} from "@/common/theme-tokens"
import "@/assets/css/cabinet-modern.css"

import HamburgerMenu from '@/components/Modals/HamburgerMenu'

import Dashboard from '@/components/FullscreenPages/Dashboard'
import Personal from '@/components/FullscreenPages/Personal'
import Deposit from '@/components/FullscreenPages/Deposit'
import Withdrawal from '@/components/FullscreenPages/Withdrawal'
import Verification from '@/components/FullscreenPages/Verification'
import Accounts from '@/components/FullscreenPages/Accounts'
import Support from '@/components/FullscreenPages/Support'
import Savings from '@/components/FullscreenPages/Savings'
import Settings from '@/components/FullscreenPages/Settings'
import {DEPOSITS_GET, DOCUMENTS_GET, LOGOUT, OTP_CREATE, WITHDRAWALS_GET} from "@/store/actions.type"
export default {
    name: 'Fullscreen',
    components: {
        Dashboard,
        Personal,
        Deposit,
        Withdrawal,
        Verification,
        Accounts,
        Support,
        Savings,
        Settings,
        HamburgerMenu
    },
    data() {
        return {
            isMobile: isMobile(),
            logo: LOGO,
            website: WEBSITE,
            tradingViewTheme: TRADINGVIEW_THEME,
            moduleFtd: MODULE_FTD,
            whiteTheme: WHITE_THEME,
            defaultWhiteTheme: DEFAULT_WHITE_THEME,
            onlyWhiteTheme: ONLY_WHITE_THEME,
            logoRedirectTo: LOGO_REDIRECT_TO
        }
    },
    mounted(){
        if(this.defaultWhiteTheme){
            if(!localStorage.getItem('theme')){
                this.switchTheme()
            }
        }
        if(this.lightTheme) {
            document.body.classList.add('light-theme');
        }

        if(this.onlyWhiteTheme){
            (localStorage.getItem('theme')) == 'black' ? this.switchTheme() : ''
        }
    },
    methods: {
        ...mapMutations(["setLightTheme",'setThemeColors']),
        logoClickHandler(e) {
            if(this.logoRedirectTo) {
                e.preventDefault()
                this.$store.commit(MODAL, {
                    fullscreen: true
                })

                this.$store.commit(MODAL,{
                    hamburgerMenu: false
                })
                
                let page = this.logoRedirectTo.replace("page:","")
                if(page) {
                    this.$store.commit(MODAL_FULLSCREEN, {
                        page
                    })
                }
            }
        },
        switchTheme(){
            this.setLightTheme(!this.lightTheme)
            localStorage.setItem('theme',this.lightTheme ? 'white' : 'black')
            localStorage.setItem('tradingview.current_theme.name',this.lightTheme ? 'Light' : TRADINGVIEW_THEME)

            let theme = this.lightTheme ? 
                {
                    ...this.themeColors,
                    'background-dark': '#fff',
                    'line': '#fff'
                } : 
                {
                    ...this.themeColors,
                    'background-dark': TRADINGVIEW_BG,
                    'line': TRADINGVIEW_LINE
                }

            this.setThemeColors(theme)
            
            if (document.body.classList.contains('light-theme')) {
                document.body.classList.remove('light-theme');
            }

            if (this.lightTheme) {
                document.body.classList.add('light-theme');
            }
        },
        close() {
            this.$store.commit(MODAL, {
                fullscreen: false
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })
        },
        changePage(page) {
            this.$store.commit(MODAL_FULLSCREEN, {
                page
            })
        },
        logout() {
            this.$store.dispatch(LOGOUT)
        },
        errorHandler(){
            this.logo.url = ''
        }
    },
    computed: {
        ...mapGetters(['user', 'tokens', 'modals', 'modalFullscreen','lightTheme','themeColors']),
        modernCabinet() {
            return CABINET_DESIGN === 'clean'
        },
        cabinetStyle() {
            return this.modernCabinet ? tokenOverrides('cab', CABINET_VARIABLES) : {}
        },
        logoComputed() {
            return this.lightTheme ? this.logo.url.replace(/white/, 'black') : this.logo.url
        }
    },
    watch: {
        modalFullscreen: {
            deep: true,
            handler(val) {
                switch (val.page) {
                    case 'deposit':
                        this.$store.dispatch(DEPOSITS_GET)
                        break
                    case 'withdrawal':
                        this.$store.dispatch(WITHDRAWALS_GET)
                        break
                    case 'verification':
                        this.$store.dispatch(DOCUMENTS_GET)
                        break
                    case 'settings':
                        if (!this.user.otp) {
                            this.$store.dispatch(OTP_CREATE)
                        }
                        break
                }
                this.$refs.fullscreen.scrollTo({ top: 0, behavior: 'smooth' })
            }
        }
    }
}
</script>

<style scoped>

.fullscreen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    background: var(--background-dark);
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-template-rows: 76px 1fr;
    overflow-y: scroll;
    align-items: stretch;
    height: 100vh;
}


.fullscreen aside {
    position: static;
}

.support{
    height: 100%;
}

header {
    grid-column: 1/-1;
    border-bottom: 1px solid rgba(144, 189, 255, 0.3);
    background: var(--background-dark-mid);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 20;
    padding: 0 31px 0 32px;
}

header a {
    text-decoration: none;
}

header img {
    max-height: 50px;
    max-width: 200px;
}

header span {
    font-size: 24px;
    font-weight: 800;
}

.trading-btn {
    background: #2B834E;
    font-weight: 400;
    font-size: 18px;
}

.cabinet-item {
    padding: 2vw 10vw;
}

.dashboard {
    background-color: var(--background-dark);
}

main {
    overflow: scroll;
}

main.fs {
    background-color: var(--background-dark);
}

/* ================================ mobile */

header.mobile {
    position: fixed;
    width: 100%;
    height: auto;
}

.fullscreen.mobile header {
    padding: 3px 15px;
}

.fullscreen.mobile .cabinet-item {
    padding: 80px 20px;
}

.fullscreen.mobile {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-auto-rows: auto;
}

.fullscreen.mobile > * {
    grid-column: 1/2;
}

.support.mobile .send {
    bottom: 5%;
}

.empty-aside {
    display: none;
}

.menu.mobile {
    position: fixed;
    height: 100%;
    background: rgba(30, 33, 58, 1);
    display: none;
    z-index: 10;
    padding-top: 60px;
}

.empty {
    width: 24px;
    height: 24px;
}

@media (min-width: 1000px) {
    .fullscreen {
        grid-template-rows: 4vw 1fr;
    }

    header.fs {
        padding: 0 1.5vw;
    }

    header.fs .trading-btn {
        padding: .7vw 2.7vw;
        font-size: 1.1vw;
        border-radius: .3vw;
        font-weight: 300;
    }

    header.fs img {
        max-width: 10vw;
        max-height: 2.6vw;
    }

    header.fs span {
        font-size: 1.3vw;
    }
}

@media (max-width: 1376px) {
    .cabinet-item {
        padding: 40px 30px;
    }
}

@media (max-width: 1000px) {

    header span {
        font-size: 16px;
    }
}

@media (max-width: 500px) {

    header img {
        max-height: 30px;
    }
}

</style>
